import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendFile } from "../../../../../redux/actions/audioEngineer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SendFilePopup({ isOpen, onClose, fileUrl }) {
  const dispatch = useDispatch()
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    const reqBody ={
      url: fileUrl,
      to: email,
      subject: "Mastered File",
      message,
    }

    try {
      dispatch(sendFile(toast, reqBody))
    } catch (err) {
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl text-theme_clr2 font-semibold mb-4">Send File</h2>

        <form className="space-y-4">
          {/* Email input */}
          <div>
            <label className="block text-sm font-medium text-theme_clr1">
              Recipient Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full mt-1 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="example@email.com"
            />
          </div>

          {/* Message input */}
          <div>
            <label className="block text-sm font-medium text-theme_clr1">
              Message
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full mt-1 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              rows="3"
              placeholder="Write your message..."
            ></textarea>
          </div>

          {/* File URL shown as attachment */}
          <div>
            <label className="block text-sm font-medium text-theme_clr1">
              File Attachment
            </label>
            <input
              type="text"
              value={fileUrl}
              readOnly
              className="w-full mt-1 p-2 border rounded-lg bg-gray-100 text-gray-600"
            />
          </div>

          {/* Success / Error Messages */}
          {success && <p className="text-green-600 text-sm">{success}</p>}
          {error && <p className="text-red-600 text-sm">{error}</p>}

          {/* Buttons */}
          <div className="flex justify-end gap-3 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg border border-gray-300 text-theme_clr2 hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              onClick={handleSubmit}
              className="px-4 py-2 rounded-lg bg-theme_clr2 text-white hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
